import type { Analysis } from '@pen/shared';

export const COLORS = { ink: '#1d1d1b', cobalt: '#1f4fd1', vermilion: '#e0452b', green: '#2f8a4f', muted: '#9a958a' };
export function ramp(f: number): string {
  return `rgb(${[31, 79, 209].map((v, i) => Math.round(v + ([224, 69, 43][i]! - v) * f)).join(',')})`;
}
export function drawPoints(ctx: CanvasRenderingContext2D, pts: readonly (readonly number[])[], upToDt = Infinity): void {
  let k = 0;
  ctx.beginPath();
  for (const p of pts) {
    if (p[2]! > upToDt) break;
    if (k++) ctx.lineTo(p[0]!, p[1]!); else ctx.moveTo(p[0]!, p[1]!);
  }
  if (k === 1 && pts[0]) ctx.lineTo(pts[0][0]! + .1, pts[0][1]!);
  if (k) ctx.stroke();
}
export function renderAt(ctx: CanvasRenderingContext2D, a: Analysis, time: number, view: 'ink' | 'process' = 'ink', background: CanvasImageSource | null = null, backgroundHeight = 560, inkWidth = 2): void {
  ctx.save();
  ctx.fillStyle = '#fffdf8'; ctx.fillRect(0, 0, a.page.w, a.page.h);
  if (background) ctx.drawImage(background, 0, 0, a.page.w, backgroundHeight);
  ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  const last = Math.max(1, a.strokes.length - 1);
  for (const s of a.strokes) {
    if (s.t0 > time) break;
    const erased = a.erasedAt.get(s.id), gone = erased != null && erased <= time;
    if (view === 'ink' && gone) continue;
    ctx.setLineDash(view === 'process' && gone ? [4, 4] : []);
    ctx.strokeStyle = view === 'ink' ? COLORS.ink : gone ? COLORS.muted : ramp(s.index / last);
    ctx.lineWidth = view === 'ink' ? inkWidth : gone ? 1.5 : 2.2;
    drawPoints(ctx, s.pts, time - s.t0);
  }
  ctx.setLineDash([]);
  if (view === 'process') {
    ctx.font = '600 12px ui-monospace, monospace'; ctx.textBaseline = 'bottom'; ctx.lineWidth = 3; ctx.strokeStyle = '#fffdf8';
    for (const burst of a.bursts) {
      if (burst.t0 > time) break;
      const s = burst.strokes[0], p = s?.pts[0]; if (!s || !p) continue;
      ctx.strokeText(String(burst.i), p[0] - 12, p[1] - 4);
      ctx.fillStyle = ramp(s.index / last); ctx.fillText(String(burst.i), p[0] - 12, p[1] - 4);
    }
  }
  ctx.restore();
}
export function loadBackground(path: string | null): Promise<HTMLImageElement | null> {
  if (!path) return Promise.resolve(null);
  // The web target is ES2023 (iPad Safari), before Promise.withResolvers.
  return new Promise<HTMLImageElement | null>((resolve, reject) => {
    const image = new Image(); image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Could not load the exercise diagram.'));
    image.src = '/content/assets/' + path;
  });
}
